export default __webpack_public_path__ + "static/media/MicroBit.ba632e29.png";